// useSanityData.js
import { useState, useEffect } from 'react';
import { client, urlFor } from '../client';

function useSanity() {
  const [dataLoaded, setDataLoaded] = useState(false); // Add a loading state
  const [experiences, setExperiences] = useState([]);
  const [skills, setSkills] = useState([]);
  const [abouts, setAbouts] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [brands, setBrands] = useState([]);
  const [works, setWorks] = useState([]);
  const [categories, setCategories] = useState([]);
  const [profile, setProfile] = useState({});
  const [profileImage, setProfileImage] = useState('');
  const [contacts, setContacts] = useState({});
  const [socialLinks, setSocialLinks] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const experienceQuery = `*[_type == "workhistory"]{
          jobTitle,
          jobDescription,
          startDate,
          endDate,
          isCurrentWorking,
          companyRef->{
            brandLogo,
            brandTitle,
            showOnFrontend,
          }
        }`;

        const skillsQuery = '*[_type == "skills"]';

        const aboutsQuery = '*[_type == "abouts"]';

        const testimonialsQuery = '*[_type == "testimonials"]';

        const brandsQuery = '*[_type == "brands"]';

        const worksQuery =
          '*[_type == "works"]{_id,title, description, imgUrl, codeLink, category[]->{title}, showcase[]->{project,titleOne,descriptionOne,mockUpImageOne,showDeployBtn,titleTwo,descriptionTwo,mockUpImageTwo,technologyDescription,techStack,deploymentTitle,deploymentDescription,deploymentImage,thirdTitle,thirdDescription,thirdImage,sourceCodeLink,sourceCodeImage,showSourceCodeBtn}}';

        const categoriesQuery = '*[_type == "category"]{title}';

        const profileQuery = '*[_type == "profile"][0]';

        const [
          experienceData,
          skillsData,
          aboutsData,
          testimonialsData,
          brandsData,
          worksData,
          categoriesData,
          profileData,
        ] = await Promise.all([
          client.fetch(experienceQuery),
          client.fetch(skillsQuery),
          client.fetch(aboutsQuery),
          client.fetch(testimonialsQuery),
          client.fetch(brandsQuery),
          client.fetch(worksQuery),
          client.fetch(categoriesQuery),
          client.fetch(profileQuery),
        ]);

        setExperiences(experienceData);
        setSkills(skillsData);
        setAbouts(aboutsData);
        setTestimonials(testimonialsData);
        setBrands(brandsData);
        setWorks(worksData);
        setCategories(categoriesData);
        setProfile(profileData);
        setProfileImage(urlFor(profileData.profileImage).url());
        const contact = profileData.contact || {};
        const social = contact.socialMedia || {};
        setContacts(contact);
        setSocialLinks(social);
    

        // Mark data as loaded
        setDataLoaded(true);
      } catch (error) {
        console.error('Error fetching Sanity data:', error);
      }
    };

    fetchData();
  }, []);

  // All data is loaded or an error occurred
  return {
    experiences,
    skills,
    abouts,
    testimonials,
    brands,
    works,
    categories,
    profile,
    profileImage,
    contacts,
    socialLinks,
    loading: !dataLoaded, // Mark loading as complete when data is loaded
  };
}

export default useSanity;
